import { useState } from 'react';
import Navbar from '../inventory/components/Navbar';
import Footer from '../home/components/Footer';

const reviews = [
  {
    id: 1,
    rating: 5,
    text: 'Amazing experience from start to finish! The team at iCarga made buying my first car so easy. No pressure, transparent pricing, and they even delivered it to my home in Lithonia. Highly recommend!',
    name: 'Sarah Johnson',
    verified: true,
    avatar: 'https://public.readdy.ai/ai/img_res/5d07e08cbd32399c1c19c13ef6a2e169.jpg'
  },
  {
    id: 2,
    rating: 5,
    text: 'I traded in my old car and got a great deal on a 2022 RAV4. The financing process was quick and painless. The staff was friendly and knowledgeable. Best car buying experience I have ever had!',
    name: 'Michael Chen',
    verified: true,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20friendly%20smiling%20asian%20man%20wearing%20casual%20button%20up%20shirt%20against%20clean%20neutral%20background%20with%20soft%20professional%20studio%20lighting&width=100&height=100&seq=avatar2&orientation=squarish'
  },
  {
    id: 3,
    rating: 5,
    text: 'Found exactly what I was looking for at a fair price. The entire process was smooth and hassle-free. They answered all my questions and made sure I was comfortable with my purchase. Will definitely recommend to friends!',
    name: 'Jennifer Martinez',
    verified: true,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20warm%20smiling%20hispanic%20woman%20with%20long%20dark%20hair%20wearing%20modern%20casual%20attire%20against%20clean%20neutral%20background%20with%20soft%20professional%20lighting&width=100&height=100&seq=avatar3&orientation=squarish'
  },
  {
    id: 4,
    rating: 5,
    text: 'Excellent service and great selection of vehicles. The team was patient with all my questions and helped me find the perfect car within my budget. Very professional and trustworthy!',
    name: 'David Thompson',
    verified: true,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20confident%20smiling%20caucasian%20man%20with%20short%20hair%20wearing%20business%20casual%20attire%20against%20clean%20neutral%20background%20with%20soft%20professional%20lighting&width=100&height=100&seq=avatar4&orientation=squarish'
  },
  {
    id: 5,
    rating: 5,
    text: 'Best car dealership in Lithonia! They made the entire process stress-free and transparent. I appreciated their honesty and the quality of the vehicle I purchased. Highly recommended!',
    name: 'Lisa Anderson',
    verified: true,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20friendly%20smiling%20woman%20with%20blonde%20hair%20wearing%20modern%20casual%20attire%20against%20clean%20neutral%20background%20with%20soft%20professional%20lighting&width=100&height=100&seq=avatar5&orientation=squarish'
  },
  {
    id: 6,
    rating: 5,
    text: 'Outstanding customer service! They went above and beyond to help me get approved for financing. The car I bought is in excellent condition and exactly what I needed. Thank you iCarga!',
    name: 'Robert Williams',
    verified: true,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20warm%20smiling%20african%20american%20man%20wearing%20casual%20shirt%20against%20clean%20neutral%20background%20with%20soft%20professional%20lighting&width=100&height=100&seq=avatar6&orientation=squarish'
  }
];

export default function ReviewsPage() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextReview = () => {
    setCurrentIndex((prev) => (prev + 1) % reviews.length);
  };

  const prevReview = () => {
    setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="pt-32 pb-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">Customer Reviews</h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
              See what our satisfied customers have to say about their experience with iCarga
            </p>
            <div className="flex items-center justify-center gap-3">
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-2xl"></i>
                ))}
              </div>
              <span className="text-3xl font-bold text-gray-900">4.9/5</span>
              <span className="text-gray-500 text-base">(500+ reviews)</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {reviews.map((review) => (
              <div
                key={review.id}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow"
              >
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(review.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                <p className="text-gray-700 leading-relaxed mb-6" style={{ lineHeight: '1.6' }}>
                  {review.text}
                </p>
                <div className="flex items-center gap-4 pt-6 border-t border-gray-100">
                  <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
                    <img
                      src={review.avatar}
                      alt={review.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <p className="font-bold text-gray-900">{review.name}</p>
                    <p className="text-sm text-gray-500">Verified Buyer</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex items-center justify-center gap-4">
            <button
              onClick={prevReview}
              className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-gray-300 text-gray-600 hover:border-[#2563EB] hover:text-[#2563EB] transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>
            <button
              onClick={nextReview}
              className="w-12 h-12 flex items-center justify-center rounded-full bg-[#2563EB] text-white hover:bg-[#1d4ed8] transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
